import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";

const PieChartType = (props) => {

  const getOptions = () => ({

    Download:true,
    title: {
        text: props.title,
        subtext: props.subTitle,
        left: 'center'
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        orient: 'vertical',
        left: 'left'
      },
    series: [
  {
    name: 'Tipo de aplicación',
    type: 'pie',
    radius: '50%',
    data: props.data,
    label: {
      show: true,
      position: 'outside', // Esto asegura que los labels se ubiquen fuera del pie
      formatter: '{b}: {c}',
      fontSize: 12
    },
    labelLine: {
      show: true
    },
    emphasis: {
      itemStyle: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      }
    }
  }
]

  });
  return (
    <div className="">
      <ReactEcharts       
      ref={props.chartRef}
      option={getOptions()} 
      style={{ height: 300 }} 
      />
    </div>
  );
}


export default PieChartType
